export default __webpack_public_path__ + "static/media/game.89bc0f8b.PNG";